import { render, staticRenderFns } from "./TodaysAppraisalStatusTotal.vue?vue&type=template&id=1bc15387&scoped=true&"
import script from "./TodaysAppraisalStatusTotal.vue?vue&type=script&lang=js&"
export * from "./TodaysAppraisalStatusTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc15387",
  null
  
)

export default component.exports